import React from 'react'
import { useInfiniteHits, UseInfiniteHitsProps } from "react-instantsearch";
import { BaseHit, Hit } from "instantsearch.js";
import { LeumitDoctorType } from "types";
import mergedSettings from "assets/mergeSettings";
import styles from "./DoctorsInBranch.module.scss";


export default function HitsResults(props: UseInfiniteHitsProps) {
  const { hits, showMore,  isLastPage} = useInfiniteHits(props);
  return (
    <div className={styles.results}>
        <ul>
        {hits.filter((hit: Hit<BaseHit>) => hit.doctorType != 3).map((hit: Hit<BaseHit>) => {
        return <li><a href={`${hit.objectType == 'Doctor'
                        ? mergedSettings.doctorPage
                        : (hit.objectType == 'Diet'
                          ? mergedSettings.dietPage
                          : mergedSettings.socialWorkerPage)
                        }${hit.licenseId ? `?licenseId=${hit.licenseId}` : ''
                        }${hit.medicalFieldFieldCode ? `${hit.licenseId ? '&' : '?'}code=${hit.medicalFieldFieldCode}` : ''
                        }${hit.doctorType ? `${hit.licenseId || hit.medicalFieldFieldCode ? '&' : '?'}doctorType=${hit.doctorType}` : ''
                        }${hit.place ? `${hit.licenseId || hit.medicalFieldFieldCode || hit.doctorType ? '&' : '?'}place=${hit.place}` : ''
                        }`}>{(hit as LeumitDoctorType).title} {(hit as LeumitDoctorType).firstName} {(hit as LeumitDoctorType).lastName}</a><p>{(hit as LeumitDoctorType).medicalFieldName}</p></li>
      })
      }
      </ul>
      {!isLastPage && <a className={styles.expend} onClick={showMore}>
      <span className={styles.show}>עוד רופאים</span>
      </a>
      }
    </div>
  )

}
